// QrDisplay — 二维码展示
// 将房间加入链接编码为二维码，供移动端扫码加入
// 使用 qrcode.react 的 QRCodeSVG（纯前端生成，不泄露给第三方）

import { QRCodeSVG } from 'qrcode.react';
import { useToastStore } from '../common/Toast';

interface QrDisplayProps {
  url: string;
  pin?: string;
  onClose: () => void;
}

export function QrDisplay({ url, pin, onClose }: QrDisplayProps) {
  const toast = useToastStore((s) => s.show);
  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast('链接已复制', 'success');
    } catch {
      toast('复制失败，请手动选择', 'error');
    }
  };

  return (
    <div className="card p-6 max-w-sm w-full text-center animate-slide-up">
      <h3 className="text-lg font-bold text-ink mb-1">扫码连接</h3>
      <p className="text-xs text-muted mb-5">用另一台设备的相机扫描下方二维码</p>

      <div className="inline-block p-4 bg-white rounded-xl shadow-card border border-border/60">
        <QRCodeSVG
          value={url}
          size={220}
          level="M"
          marginSize={1}
          aria-label="房间二维码"
        />
      </div>

      {pin && (
        <div className="mt-5 rounded-md bg-warning/10 border border-warning/30 px-4 py-3">
          <p className="text-xs text-muted">如需 PIN 校验，请输入</p>
          <p className="text-2xl font-bold tracking-[0.4em] text-ink mt-1">{pin}</p>
        </div>
      )}

      <div className="mt-5 flex gap-2">
        <button type="button" onClick={copyLink} className="btn-outline flex-1">
          🔗 复制链接
        </button>
        <button type="button" onClick={onClose} className="btn-ghost">
          关闭
        </button>
      </div>
    </div>
  );
}
